module.exports = __webpack_public_path__ + "assets/img/5.62e7e759.png";